module.exports = __webpack_public_path__ + "img/Fqlaxf2XoAA9VKQ.ca1022d5.jpeg";